import React, {useEffect, useRef, useState} from 'react';
import { Calendar, theme } from 'antd';
import type { CalendarProps } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import {formatDate, getImagePathWithTheme, isCardEmpty} from "@/utils";
import {isZh} from "@/language";
import {MAP_MONTH_FULL} from "@/Const";
import { t } from 'i18next';
import updateData from 'dayjs/plugin/updateLocale'
import enGB from 'antd/lib/calendar/locale/en_GB'

dayjs.extend(updateData);

interface DatePickerPopupProps {
  x: number;
  y: number;
  defaultDate?: string; // 默认日期参数
  onDateSelect: (date: string, ifCloseDateDialog: boolean) => void;
  onClose: () => void;
}

const DatePickerPopup: React.FC<DatePickerPopupProps> = ({ x, y, defaultDate, onDateSelect, onClose }) => {
    const ifClickMonthOrYearSelectOption = React.useRef(false);
    const { token } = theme.useToken();
  const dayJsDefaultDate = defaultDate && defaultDate !== '-1' && defaultDate !== '0'
      ? dayjs(Number(defaultDate))
      : dayjs()
  // 处理默认日期
  const [selectDate,setSelectDate] = useState<any>(dayJsDefaultDate);

  const mIsChangeMonth = useRef(false);
  const mIsDateClicked = useRef(false);

    useEffect(() => {
        const handleCalenderClick = (event) => {
            const target = event.target as HTMLElement;

            if (target.tagName === "DIV" && (target.classList.contains("ant-select-item-option-content") || target.matches("div.ant-select-item.ant-select-item-option.ant-select-item-option-active"))) {
                ifClickMonthOrYearSelectOption.current = true
            } else {
                ifClickMonthOrYearSelectOption.current = false
            }
        }
        document.addEventListener("click", handleCalenderClick);
        return () => {
            document.removeEventListener("click", handleCalenderClick);
        }
    }, [])

  const wrapperStyle: React.CSSProperties = {
    position: 'fixed',
    top: y,
    left: x,
    width: 300,
    padding:'10px 6px 2px 6px',
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadiusLG,
    backgroundColor: 'white',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    zIndex: 9999,
  };

  const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9998,
  };
  const noDuedateStyle: React.CSSProperties = {
    fontSize: '14px',
    borderTop: '1px solid #dcdcdc',
    // textAlign:'center',
    height: '40px',
    lineHeight: '40px',
    paddingLeft: '10px',
    cursor: 'pointer'
  };

  const onPanelChange = (value: Dayjs, mode: CalendarProps<Dayjs>['mode']) => {
    console.log(value.format('YYYY-MM-DD'), mode);
  };

  const onSelect = (value: Dayjs) => {
    const dateString = value.format('YYYY-MM-DD');
    onDateSelect(dateString);
    onClose();
  };
  const noDuedateClick = () => {
    onDateSelect('-1');
    onClose();
  };

  const getMonthDesc = (value:any)=>{
      if (!value.month){
          value = dayjs(value);
      }
    const selectMonth = value.month() + 1
    if (isZh()){
      return formatDate(value,'yyyy年MM月')
    }
    return t(MAP_MONTH_FULL[`${selectMonth}`]) + '　' + value.year();
  }

  /**
   * 头部
   */
  const calendarHeaderRender = ({value, type, onChange, onTypeChange})=>{

    return <div className={'flex-row-vertical-center'} style={{padding: '6px 10px 12px 10px'}}>
            <span className={'font-family-semi-bold'}
                  style={{color: 'var(--primary-color)'}}>{getMonthDesc(value)}</span>
      <div style={{flexGrow:'1'}}></div>
      <img className={'img-18 cursor-pointer'}
           src={getImagePathWithTheme('calendar_month_left')}
           onClick={(event) => {
               event.stopPropagation();
             mIsChangeMonth.current = true;
             mIsDateClicked.current = false;
             const newValue = value.clone().month(value.month() - 1);
             setSelectDate(newValue);
             onChange(newValue);
           }}/>
      <img className={'img-18 ml-22 cursor-pointer'} src={getImagePathWithTheme('calendar_month_right')}
           onMouseDown={(event)=>{
               event.stopPropagation();
           }}
           onClick={(event) => {
               event.stopPropagation();
             mIsDateClicked.current = false;
             mIsChangeMonth.current = true;
             const newValue = value.clone().month(value.month() + 1)
             setSelectDate(newValue);
             onChange(newValue)
           }}/>
    </div>
  }

  const calendarCellRender = (current:any, info) => {
    if (info.type === 'date') {
      const szCurrentFormat = formatDate(current.$d, 'yyyyMMdd');
      const szCurrentDate = formatDate(new Date(), 'yyyyMMdd');
      const isCurDay = szCurrentDate == szCurrentFormat;
      let isSelectedDate = (mIsDateClicked.current ||  formatDate(dayJsDefaultDate.toDate().getTime(),'yyyyMMdd') == szCurrentFormat) && formatDate(selectDate,'yyyyMMdd') == szCurrentFormat;
      const isSelectedMonth = current.month() == selectDate.month()
        const hasJournal = false;

      const getTextColor = ()=>{
        if (isSelectedDate){
          return 'white';
        }

        if (!isSelectedMonth){
          return 'var(--color-7d7d7d)';
        }
        if (isCurDay){
          return 'var(--primary-color)';
        }

        return 'var(--text-color)';
      }

      return (
          <div className={'flex-center'} onClick={(e)=>{
              onSelect(dayjs(current));
          }}>
            <div className="ant-picker-cell-inner1"
                 style={{
                   display:'flex',flexDirection:'column',
                   justifyContent:'center',
                   alignItems:'center',
                   width:'28px',height:'28px',
                   border: "none",
                   borderRadius: '20px',
                   textAlign:'center',
                   background:(isSelectedDate)?'var(--primary-color)':'transparent'
                 }}>
              {/*{current.date()}*/}
              <span
                  style={{color: getTextColor(),lineHeight:'28px',marginTop:'-3px'}}>{current.date()}</span>
              <span style={{
                marginTop: '-6px',
                width: '4px',
                height: '4px',
                borderRadius: '2px',
                background: (isSelectedDate )?'white':'var(--primary-color)',
                display: hasJournal ? 'block' : 'none',
              }}></span>
            </div>
          </div>

      );
    }
    return info.originNode;
  }

  return (
    <>
      {/* 背景遮罩，点击关闭弹窗 */}
      <div style={overlayStyle} onClick={onClose} />
      {/* 日历弹窗 */}
      <div style={wrapperStyle}>
        <Calendar
            locale={enGB}
            value={(selectDate)}
          headerRender={calendarHeaderRender}
          fullCellRender={calendarCellRender}
          fullscreen={false}
        />
        <div onClick={noDuedateClick} style={noDuedateStyle}>
          {t("NoDuedate")}
        </div>
      </div>
    </>
  );
};

export default DatePickerPopup;